import './customDateTimePicker.scss';
import {DatePicker} from 'antd';
import AddDayField from './AddDayField';
import React from 'react';
import dayjs from 'dayjs';

const CustomDateTimePicker = ({
                                  rows,
                                  handleSetRows,
                                  hasTime = true,
                                  disabled = false,
                                  hasAdd = true,
                                  isUnixTime = true
                              }) => {
    const handleDateChange = (name, value) => {
        if (value === null || value === undefined) return;
        if (isUnixTime) {
            switch (name) {
                case 'begin':
                    if (hasTime) {
                        value = dayjs(value).startOf('minute').unix();
                    } else {
                        value = dayjs(value).startOf('day').unix();
                    }
                    break;
                case 'end':
                    if (hasTime) {
                        value = dayjs(value).endOf('minute').unix();
                    } else {
                        value = dayjs(value).endOf('day').unix();
                    }
                    break;
            }
        } else {
            if (value !== null) {
                switch (name) {
                    case 'begin':
                        if (hasTime) {
                            value = dayjs(value).startOf('minute').format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            value = dayjs(value).startOf('day').format('YYYY-MM-DD HH:mm:ss');
                        }
                        break;
                    case 'end':
                        if (hasTime) {
                            value = dayjs(value).endOf('minute').format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            value = dayjs(value).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                        }
                        break;
                }
            }
        }
        handleSetRows(name, value);
    };

    const getDatePickerFormat = () => {
        return hasTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
    }

    const getDatePickerShowTime = () => {
        return hasTime ? {format: 'HH:mm'} : false;
    }

    return (
        <div className="custom-data-time-picker">
            <DatePicker
                showTime={getDatePickerShowTime()}
                format={getDatePickerFormat()}
                value={isUnixTime ? dayjs.unix(rows?.begin) : dayjs(rows?.begin)}
                onChange={value => handleDateChange('begin', value)}
                disabled={disabled}
                style={{marginRight: 8, width: 160}}
                placeholder="시작일시"
            />
            {hasAdd ? (
                <AddDayField
                    rows={rows}
                    handleSetRows={handleSetRows}
                    isUnixTime={isUnixTime}
                    hasTime={hasTime}
                    disabled={disabled}
                />
            ) : (
                <div style={{width: 100}}/> // Placeholder for spacing when hasAdd is false
            )}
            <DatePicker
                showTime={getDatePickerShowTime()}
                format={getDatePickerFormat()}
                value={isUnixTime ? dayjs.unix(rows?.end) : dayjs(rows?.end)}
                onChange={value => handleDateChange('end', value)}
                disabled={disabled}
                style={{marginRight: 8, width: 160}}
                placeholder="종료일시"
            />
        </div>
    );
};

export default CustomDateTimePicker;